<template>
  <GridContainer
    :is-fluid="isFluid"
    class="promotions"
  >
    <StageSlider
      v-if="promotions"
      :stage-slides-data="promotions"
      class="promotions__stage-slider"
    />
    <Heading
      size="md"
      align="center"
      spaces-top
      spaces-bottom
      font-weight="ultra"
      class="promotions__heading"
    >
      Herzlich Willkommen im Telekom Zubehörshop
    </Heading>
  </GridContainer>
</template>

<script setup lang="ts">
import { GridContainer, Heading } from '@i22team/td-longtail-vue-components';
import StageSlider from '~/components/stage-slider.vue';
import type { StageSliderData } from '~/lib/promotions-type';

export type PromotionsProps = {
  promotions?: StageSliderData[];
  isFluid?: boolean;
};

withDefaults(defineProps<PromotionsProps>(), {
  promotions: undefined,
  isFluid: false,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.promotions {
  &__stage-slider {
    height: calc(588px + 44px + 0.5rem); // space for pagination

    @include mq($mq-sm) {
      height: calc(430px + 44px + 0.5rem);
    }

    @include mq($mq-md) {
      height: calc(530px + 44px + 0.5rem);
    }
  }

  &:deep(.stage-slide) {
    --stage-slide-height: 578px;
    height: var(--stage-slide-height);
    grid-template-rows: var(--stage-slide-height);

    @include mq($mq-sm) {
      --stage-slide-height: 420px;
    }

    @include mq($mq-md) {
      --stage-slide-height: 520px;
    }
  }

  &__heading {
    padding-inline: $grid-base;
  }
}
</style>
